import { render, staticRenderFns } from "./outRecordAdmin.vue?vue&type=template&id=dcedee5a&scoped=true"
import script from "./outRecordAdmin.vue?vue&type=script&lang=js"
export * from "./outRecordAdmin.vue?vue&type=script&lang=js"
import style0 from "./outRecordAdmin.vue?vue&type=style&index=0&id=dcedee5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcedee5a",
  null
  
)

export default component.exports